export default __webpack_public_path__ + "static/media/home-design-agency-bg-img-01.9ba74ac7.png";